/** Shared z-index layers for modal UI. */
export const MODAL_LAYERS = {
  overlay: 9999,
  content: 10000,
  apiError: 10003,
} as const
